export default __webpack_public_path__ + "static/media/edit.53e2a7c1.svg";